import { Controller } from "@hotwired/stimulus"

// Controls the tabbed authentication settings in user profile
// Allows switching between OAuth, Manual Token, and API Key tabs
// Supports multiple instances on the same page via data-auth-tabs-storage-key attribute
export default class extends Controller {
  static targets = ["tab", "content"]

  connect() {
    const storageKey = this.element.dataset.authTabsStorageKey || "authSettingsTab"
    const savedTab = localStorage.getItem(storageKey)
    const firstTab = this.tabTargets[0]?.dataset.tab

    // Use saved tab if it exists and matches a known tab, otherwise default to first tab
    const knownTabs = this.tabTargets.map(t => t.dataset.tab)
    const tabToShow = (savedTab && knownTabs.includes(savedTab)) ? savedTab : firstTab

    if (tabToShow) this.showTab(tabToShow)
  }

  switchTab(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tab
    const storageKey = this.element.dataset.authTabsStorageKey || "authSettingsTab"
    this.showTab(tabName)
    localStorage.setItem(storageKey, tabName)
  }

  showTab(tabName) {
    // Update tab active states
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        tab.classList.add("tab-active")
      } else {
        tab.classList.remove("tab-active")
      }
    })

    // Show/hide content
    this.contentTargets.forEach(content => {
      if (content.dataset.tab === tabName) {
        content.classList.remove("hidden")
      } else {
        content.classList.add("hidden")
      }
    })
  }
}
